<template>
  <el-table
    :data="printInfoData"
    border
    ref="printInfoTable"
    max-height="400px"
    :header-cell-style="{background: '#0E1C3B', padding: '2px 0', textAlign: 'center', color: 'white', fontSize: '13px'}"
    :cell-style="{background: '#0E1C3B', padding: '2px 0', textAlign: 'center', color: 'white', fontSize: '13px'}">
    <el-table-column type="expand">
      <template slot-scope="props">
        <el-table :data="props.row.labelDetails"
                  border
                  :header-cell-style="{'background-color': '#0E1C3B', padding: '2px 0', color: 'white', textAlign: 'center', fontSize: '13px'}"
                  :cell-style="{background: '#0E1C3B', padding: '2px 0', color: 'white', textAlign: 'center', fontSize: '13px'}">
          <el-table-column label="订单子批号" width="250">
            <template slot-scope="scope">
              <el-input
                v-if="editIndex === props.$index"
                clearable
                v-model.trim="scope.row.subNo"
                autocomplete="on"
                type="text"
                maxlength="50"
                @change="changeSubNo(props.row.labelDetails, props.$index, scope.$index, props.row.result)"
              />
              <span v-else>{{scope.row.subNo}}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="editIndex === props.$index" label="产品型号" width="150">
            <template slot-scope="scope">
              {{scope.row.productName && scope.row.chipName ? scope.row.productName + '/' + scope.row.chipName : ''}}
            </template>
          </el-table-column>
          <el-table-column v-if="editIndex === props.$index" prop="partNo" label="标签上打印的PARTNO" width="200">
          </el-table-column>
          <el-table-column prop="lotNo" label="印章号" width="250">
            <template slot-scope="scope">
              {{scope.row.lotNo}}
            </template>
          </el-table-column>
          <el-table-column label="实际数量" width="120">
            <template slot-scope="scope">
              <el-input
                v-if="editIndex === props.$index"
                type="tel"
                clearable
                v-model.trim.number="scope.row.count"
                autocomplete="on"
                maxlength="7"
                @change="changeLotNoInfo(props.row.labelDetails, props.$index)"
              />
              <span v-else>{{scope.row.count}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="60">
            <template v-if="editIndex === props.$index" slot-scope="scope">
              <el-button
                :disabled="props.row.labelDetails.length === 1"
                type="text"
                @click="removeLotNoInfo(props.$index, scope.$index)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          v-if="editIndex === props.$index"
          size="small"
          class="addButton"
          icon="el-icon-plus"
          circle
          @click="addLotNoInfo(props.$index)"
        />
      </template>
    </el-table-column>
    <el-table-column label="PARTNO" width="180">
      <template slot-scope="scope">
        {{scope.row.partNo}}{{editIndex === scope.$index ? '' : scope.row.partNoSuffix}}
        <el-select
          filterable
          style="width: 80px;"
          v-if="editIndex === scope.$index"
          v-model="scope.row.partNoSuffix">
          <el-option
            v-for="(item, i) in partNoSuffixes"
            :id="item.value"
            :key="i"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </template>
    </el-table-column>
    <el-table-column prop="packageType" label="封装名称" width="150"/>
    <el-table-column prop="lotNo" label="印章号" width="150">
    </el-table-column>
    <el-table-column prop="qty" label="实际数量" width="80">
    </el-table-column>
    <el-table-column label="Tracking No" width="300">
      <template slot-scope="scope">
        <el-input
          ref="refTrackingNo"
          v-if="editIndex === scope.$index"
          clearable
          v-model="scope.row.trackingNoSub"
          placeholder="输入/扫码枪"
          autocomplete="on"
          maxlength="4"
          type="tel">
          <template slot="prepend">{{scope.row.trackingNo.substring(0, scope.row.trackingNo.length - 3)}}</template>
        </el-input>
        <span v-else>{{scope.row.trackingNo}}</span>
      </template>
    </el-table-column>
    <el-table-column label="所属箱子" width="150">
      <template slot-scope="scope">
        {{scope.row.boxLabel && scope.row.boxLabel.trackingNo}}
      </template>
    </el-table-column>
    <el-table-column label="档位" width="100">
      <template slot-scope="scope">
        <el-select
          filterable
          v-if="editIndex === scope.$index && scope.row.result"
          v-model.trim.number="scope.row.binLevel">
          <el-option
            v-for="(item, i) in passBinLevels"
            :key="i"
            :label="item.explain"
            :value="item.val">
          </el-option>
        </el-select>
        <span v-else>{{scope.row.binLevel}}</span>
      </template>
    </el-table-column>
    <el-table-column label="分选机编号" width="100">
      <template slot-scope="scope">
        <el-select
          filterable
          v-if="editIndex === scope.$index"
          v-model.trim.number="scope.row.machineHandNo">
          <el-option
            v-for="(item, i) in machineHandNoArray"
            :key="i"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <span v-else>{{scope.row.machineHandNo}}</span>
      </template>
    </el-table-column>
    <el-table-column label="dateCode" width="150">
      <template slot-scope="scope">
        <el-input
          ref="refDateCode"
          v-if="editIndex === scope.$index"
          clearable
          v-model="scope.row.dateCode"
          placeholder="输入/扫码枪"
          autocomplete="on"
          type="text"
          maxlength="10"
        />
        <span v-else>{{scope.row.dateCode}}</span>
      </template>
    </el-table-column>
    <el-table-column v-if="isErrorLabel" label="失效原因" width="150">
      <template slot-scope="scope">
        <el-select
          filterable
          v-if="editIndex === scope.$index && !scope.row.result"
          v-model.trim="scope.row.explain"
          clearable
          allow-create>
          <el-option
            v-for="(item, i) in explainArray"
            :key="i"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span v-else>{{scope.row.explain}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="result" label="结果" width="80">
      <template slot-scope="scope">
        {{scope.row.result ? 'PASSED' : 'FAILED'}}
      </template>
    </el-table-column>
    <el-table-column label="更新时间" width="110">
      <template slot-scope="scope">
        {{formatDate(scope.row.updateAt)}}
      </template>
    </el-table-column>
    <el-table-column label="操作" min-width="160" fixed="right">
      <template slot-scope="scope">
        <el-button
          size="medium"
          type="text"
          :disabled="scope.row.boxLabelId !== null || editIndex !== -1 && scope.$index !== editIndex"
          @click="updateLabel(scope.row, scope.$index)">
          {{editIndex === scope.$index ? '确定' : '更新标签'}}
        </el-button>
        <span class="separator"/>
        <el-button
          :disabled="editIndex === scope.$index"
          size="medium"
          type="text"
          @click="reprint(scope.row, scope.$index)">
          重新打印
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
  import { isPositiveIntegerNum } from '@/utils';
  import { partNoSuffixes, passBinLevels, explainArray } from '@/utils/defines';
  import { trackingInfo } from '@/api/box';

  export default {
    props: [
      'data',
      'machineHandNoArray',
      'isErrorLabel',
    ],
    data() {
      let partNo, partNoSuffix;
      const printInfoData = this.data.map(item => {
        item.trackingNoSub = item.trackingNo.substring(item.trackingNo.length - 3);
        partNo = item.partNo;
        partNoSuffix = '';
        if (partNo && partNo.endsWith('TR')) {
          partNo = partNo.substring(0, partNo.length - 2);
          partNoSuffix = 'TR';
        }
        return {...item, partNo, partNoSuffix};
      });
      return {
        editIndex: -1,
        printInfoData: printInfoData || [],
        partNoSuffixes,
        passBinLevels,
        explainArray,
      };
    },
    mounted() {
      this.scanBoxInfoBarCode();
    },
    watch: {
      data(newVal) {
        this.editIndex = -1;
        let partNo, partNoSuffix;
        this.printInfoData = newVal.map(item => {
          item.trackingNoSub = item.trackingNo.substring(item.trackingNo.length - 3);
          partNo = item.partNo;
          partNoSuffix = '';
          if (partNo && partNo.endsWith('TR')) {
            partNo = partNo.substring(0, partNo.length - 2);
            partNoSuffix = 'TR';
          }
          return {...item, partNo, partNoSuffix};
        });
      }
    },
    methods: {
      scanBoxInfoBarCode() {
        let code = '';
        let nextCode, editIndex;
        document.onkeypress = (e) => {
          editIndex = this.editIndex;
          if (this.editIndex === -1) {
            code = '';
            return;
          }
          nextCode = e.which;
          if (nextCode !== 13) {
            code += String.fromCharCode(nextCode);
          }
          if (nextCode === 13) {
            if (this.$refs.refTrackingNo && this.$refs.refTrackingNo.focused) {
              Vue.set(this.printInfoData[editIndex], 'trackingNo', code);
              this.$refs.refDateCode && this.$refs.refDateCode.focus();
            } else if (this.$refs.refDateCode && this.$refs.refDateCode.focused) {
              Vue.set(this.printInfoData[editIndex], 'dateCode', code);
            }
            code = '';
          }
        };
      },
      print(row, index) {
        this.$emit('print', row, index);
      },
      async updateLabel(row, index) {
        if (this.editIndex === -1) {
          this.editIndex = index;
          setTimeout(() => {
            this.$refs.refTrackingNo && this.$refs.refTrackingNo.focus();
          });
          this.$refs.printInfoTable && this.$refs.printInfoTable.toggleRowExpansion(row, true);
          const labelDetails = this.printInfoData[index].labelDetails;
          let subNo, info = [], res, data;
          for (let row of labelDetails) {
            subNo = row.subNo;
            try {
              res = await trackingInfo({subNo});
              data = res.data;
              info.push({
                ...row,
                productName: data.productName,
                chipName: data.chipName,
                partNo: data.partNo,
                isMixed: data.isMixed,
                incoOrdersDetailId: data.id,
              });
            } catch (e) {
              info.push({
                ...row,
              });
            }
          }
          Vue.set(this.printInfoData[index], 'labelDetails', info);
        } else {
          const {
            productName,
            lotNo,
            qty,
            trackingNo,
            trackingNoSub,
            dateCode,
            result,
            labelDetails,
          } = this.printInfoData[index];
          let newTrayNo = '';
          if (labelDetails) {
            let sortLotNoInfoObj = {};
            for (let row of labelDetails) {
              if (!this.validateLotNo(row.lotNo, productName, row.subNo)) {
                return;
              }
              if (!this.validateQty(row.count)) {
                return;
              }
              if (!sortLotNoInfoObj[row.lotNo]) {
                sortLotNoInfoObj[row.lotNo] = {...row};
              } else {
                sortLotNoInfoObj[row.lotNo].count += row.count;
              }
            }

            const sortLotNoInfo = Object.values(sortLotNoInfoObj);
            sortLotNoInfo.sort((a, b) => b.count - a.count);
            let lotNoSet = new Set();
            for (let value of sortLotNoInfo) {
              lotNoSet.add(value.lotNo);
            }

            const lotNoArray = [...lotNoSet];
            let length = lotNoArray.length;
            if (length >= 3) {
              newTrayNo = `${lotNoArray[0]}-${length}`;
            } else {
              newTrayNo = lotNoArray.join('/');
            }

            if (newTrayNo.length > 16) {
              newTrayNo = newTrayNo.substring(0, 16);
            }
            if (trackingNo && trackingNo.includes('$')) {
              newTrayNo = newTrayNo + '$' + trackingNo.split('$')[1];
            }
            if (trackingNo && trackingNo.includes('#')) {
              newTrayNo = newTrayNo + '#' + trackingNo.split('#')[1];
            }
          }
          if (!trackingNoSub || trackingNoSub && trackingNoSub.length !== 3) {
            this.$message({
              type: 'error',
              message: 'Tracking NO格式错误'
            });
            return;
          } else {
            newTrayNo = newTrayNo.substring(0, newTrayNo.length - 3) + trackingNoSub;
          }
          if (!this.validateLotNo(lotNo, productName)) {
            return;
          }
          if (!this.validateQty(qty)) {
            return;
          }
          if (!this.validateTrackingNo(newTrayNo)) {
            return;
          }
          if (!this.validateDateCode(dateCode)) {
            return;
          }
          let info = [], productNameVal, productNameChipNamePartNo;
          for (let row of labelDetails) {
            if (labelDetails.length > 1 && row.isMixed === 0 && result) {
              this.$message({
                type: 'error',
                message: '该标签存在订单子批号不允许混装'
              });
              return;
            }
            if (!row.lotNo) {
              this.$message({
                type: 'error',
                message: '子批号' + row.subNo +　'印章号为空'
              });
              return;
            }
            if (!row.productName || !row.chipName || !row.partNo) {
              this.$message({
                type: 'error',
                message: '子批号' + row.subNo + '信息异常',
              });
              return;
            }
            productNameChipNamePartNo = row.productName + '/' + row.chipName + '/' + row.partNo;
            if (productNameVal === undefined) {
              productNameVal = productNameChipNamePartNo;
            } else {
              if (productNameChipNamePartNo !== productNameVal) {
                this.$message({
                  type: 'error',
                  message: '不同产品型号芯片不能混装'
                });
                return;
              }
            }
            info.push({
              incoOrdersDetailId: row.incoOrdersDetailId,
              count: row.count,
            });
          }
          this.editIndex = -1;
          this.$emit('updateLabel', {...row, trackingNo: newTrayNo, lotNoInfo: info}, index);
          this.$refs.printInfoTable && this.$refs.printInfoTable.toggleRowExpansion(row, false);
        }
      },
      formatDate(updateAt) {
        let updateDate = moment.utc(updateAt);
        let isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
        if (isSameYear) {
          return updateDate.local().format("MM/DD HH:mm");
        } else {
          return updateDate.local().format("YYYY/MM/DD HH:mm");
        }
      },
      async changeSubNo(labelDetails, parentIndex, childIndex, result) {
        const subNo = labelDetails[childIndex] && labelDetails[childIndex].subNo;
        if (!subNo) {
          return;
        }
        let sub;
        for (let row of labelDetails) {
          if (sub === undefined) {
            sub = row.subNo;
          } else if (sub === (row.subNo)) {
            this.$message({
              message: '订单子批号重复',
              type: 'error'
            });
            return;
          }
        }
        labelDetails[childIndex] = {
          ...labelDetails[childIndex],
          lotNo: undefined,
          productName: undefined,
          chipName: undefined,
          partNo: undefined,
          isMixed: undefined,
        };
        Vue.set(this.printInfoData[parentIndex], 'labelDetails', [...labelDetails]);
        try {
          const res = await trackingInfo({subNo});
          const data = res.data;
          let {
            lotNo,
            productName,
            chipName,
            partNo,
            isMixed,
            id,
          } = data;
          labelDetails[childIndex] = {
            ...labelDetails[childIndex],
            lotNo,
            productName,
            chipName,
            partNo,
            isMixed,
            incoOrdersDetailId: id,
          };
          Vue.set(this.printInfoData[parentIndex], 'labelDetails', [...labelDetails]);
          if (labelDetails.length > 1 && isMixed === 0 && result) {
            this.$message({
              message: '该订单子批号不允许混装',
              type: 'error'
            });
            return;
          }
          let findProdNoIndex = labelDetails.findIndex(item => item.productName !== productName || item.chipName !== chipName || item.partNo !== partNo);
          if (findProdNoIndex !== -1) {
            this.$message({
              message: '不同产品型号芯片不能混装',
              type: 'error'
            });
          }
        } catch (e) {
        }
      },
      changeLotNoInfo(labelDetails, index) {
        let sortLotNoInfoObj = {};
        for (let value of labelDetails) {
          if (value.lotNo) {
            if (!sortLotNoInfoObj[value.lotNo]) {
              sortLotNoInfoObj[value.lotNo] = {...value};
            } else {
              sortLotNoInfoObj[value.lotNo].count += value.count;
            }
          }
        }
        const sortLotNoInfo = Object.values(sortLotNoInfoObj);
        sortLotNoInfo.sort((a, b) => b.count - a.count);
        let lotNo = '';
        let lotNoSet = new Set();
        for (let value of sortLotNoInfo) {
          if (value.lotNo) {
            lotNoSet.add(value.lotNo);
          }
        }
        const lotNoArray = [...lotNoSet];
        let length = lotNoArray.length;
        if (length >= 3) {
          lotNo = `${lotNoArray[0]}-${length}`;
        } else {
            lotNo = lotNoArray.join('/');
        }
        if (lotNo.length > 16) {
          lotNo = lotNo.substring(0, 16);
        }
        this.printInfoData[index].lotNo = lotNo;
        const trackingNo = this.printInfoData[index].trackingNo;
        if (trackingNo && trackingNo.includes('$')) {
          this.printInfoData[index].trackingNo = lotNo + '$' + trackingNo.split('$')[1];
        }
        if (trackingNo && trackingNo.includes('#')) {
          this.printInfoData[index].trackingNo = lotNo + '#' + trackingNo.split('#')[1];
        }
      },
      addLotNoInfo(index) {
        this.printInfoData[index].labelDetails.push({
          subNo: undefined,
          productName: undefined,
          chipName: undefined,
          partNo: undefined,
          lotNo: undefined,
          count: undefined
        });
      },
      removeLotNoInfo(rowIndex, lotNoInfoIndex) {
        this.printInfoData[rowIndex].labelDetails.splice(lotNoInfoIndex, 1);
        this.changeLotNoInfo(this.printInfoData[rowIndex].labelDetails, rowIndex);
      },
      validateLotNo(value, productName, subNo) {
        const isEmptyValue = value === undefined || (typeof value === 'string' && !value.trim());
        if (isEmptyValue) {
          this.$message({
            type: 'error',
            message: (subNo ? '子批号' + subNo : '') + '印章号为空'
          });
          return false;
        }
        if ((/^\d+$/.test(value))) {
          this.$message({
            type: 'error',
            message: (subNo ? '子批号' + subNo : '') + '印章号是纯数字'
          });
          return false;
        }
        if (!(/^[A-Za-z0-9/$#@-]+$/.test(value))) {
          this.$message({
            type: 'error',
            message: (subNo ? '子批号' + subNo : '') + '印章号格式错误'
          });
          return false;
        }
        if (value.trim() === productName) {
          this.$message({
            type: 'error',
            message: (subNo ? '子批号' + subNo : '') + '印章号和产品型号相同'
          });
          return false;
        }
        return true;
      },
      validateQty(value) {
        const isEmptyValue = value === undefined || (typeof value === 'string' && !value.trim());
        if (isEmptyValue) {
          this.$message({
            type: 'error',
            message: '数量不能为空'
          });
          return false;
        }
        if (!isPositiveIntegerNum(value)) {
          this.$message({
            type: 'error',
            message: '数量必须是正整数'
          });
          return false;
        }
        return true;
      },
      validateTrackingNo(value) {
        const isEmptyValue = value === undefined || (typeof value === 'string' && !value.trim());
        if (isEmptyValue) {
          this.$message({
            type: 'error',
            message: 'Tracking NO不能为空'
          });
          return false;
        }
        if (!(/^[A-Za-z0-9/$#@\-]+\$[0-9a-zA-Z]{6}$/.test(value)) && !(/^[A-Za-z0-9\-/$#@\-]+#[0-9a-zA-Z]{6}$/.test(value))) {
          this.$message({
            type: 'error',
            message: 'Tracking NO格式错误'
          });
          return false;
        }
        return true;
      },
      validateDateCode(value) {
        const isEmptyValue = value === undefined || (typeof value === 'string' && !value.trim());
        if (isEmptyValue) {
          this.$message({
            type: 'error',
            message: 'DateCode 不能为空'
          });
          return false;
        }
        if (!(/^\d{4}-\d{2}-\d{2}$/.test(value))) {
          this.$message({
            type: 'error',
            message: 'DateCode格式错误'
          });
          return false;
        }
        return true;
      },
      reprint(row, index) {
        this.$emit('print', {...row, partNo: row.partNo + row.partNoSuffix}, index);
      }
    }
  };
</script>
<style lang="less" scoped>
  .separator {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 5px;
    vertical-align: middle;
    background: #e8e8e8;
  }

  /deep/ .el-table__fixed-right-patch {
    background: #0E1C3B;
    border: none;
  }

  .addButton {
    margin-top: 5px;
    background: transparent;
    border: 1px solid #153772;
    color: white;
  }
  /deep/ .el-table__body-wrapper {
    z-index: 0;
  }
</style>
